import { useDispatch } from "react-redux";
import { getSearchValue } from "../../../../../../redux/reducers/ui/selectors/searchSelectors";
import { useAppSelector } from "../../../../../../redux/store";
import { Search } from "../../../../../../shared/Search/Search";
import { setSearchValueAction } from "../../../../../../redux/reducers/ui/actions/actions";

export const SearchObjects = () => {
  const dispatch = useDispatch();
  const searchValue = useAppSelector(getSearchValue);

  const handleSearchChange = (value: string) => {
    dispatch(setSearchValueAction(value));
  };
  return <Search value={searchValue} setValue={handleSearchChange} />;
};
